<div class="login-container">
  <div class="login-box">
    <h2 class="title">{{ translationService.getTranslation('login') }}</h2>
    
    <form (ngSubmit)="login()">
      <label for="email">{{ translationService.getTranslation('mail') }}</label>
      <input id="username" type="username" [(ngModel)]="username" name="username" placeholder="" required>

      <label for="password">{{ translationService.getTranslation('Contrasena') }}</label>
      <div class="password-container">
        <input id="password" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" name="password" placeholder="password" required>
        <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
          <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>

      <button type="submit" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ translationService.getTranslation('login') }}</span>
        <span *ngIf="isLoading" class="loader"></span>
      </button>
    </form>

   

    <div class="NoContrasena">
      <a href="/signup">{{ translationService.getTranslation('NoContrasena') }}</a>
    </div>


    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

    <div class="register">
      <a href="/signup">{{ translationService.getTranslation('registro') }}</a>
    </div>

    <!-- Mover el enlace de "Forgot Password" aquí -->
    
  </div>
</div>


